"use client";
import React from "react";
import * as RadixToast from "@radix-ui/react-toast";
import Icon from "./icon";

function Toast(props: RadixToast.ToastProviderProps) {
  return (
    <RadixToast.Provider
      {...props}
      duration={props.duration || 5000}
      swipeDirection="right"
    >
      {props.children}
    </RadixToast.Provider>
  );
}

function Content(
  props: RadixToast.ToastProps & React.RefAttributes<HTMLLIElement>
) {
  return (
    <>
      <RadixToast.Root
        {...props}
        className="relative items-center bg-white shadow-elevation-300 focus:shadow-elevation-400 rounded-md data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=cancel]:translate-x-0 data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[state=closed]:animate-hide data-[state=open]:animate-slideIn data-[swipe=end]:animate-swipeOut pointer-events-auto"
      >
        {props.children}
        {/* <RadixToast.Close className="top-3 right-3 absolute fill-dark">
          <Icon name="close" size="sm" />
        </RadixToast.Close> */}
      </RadixToast.Root>
      <RadixToast.Viewport className="top-32 md:top-[var(--navbar-height)] right-0 bottom-0 z-[2147483647] fixed flex flex-col gap-[10px] m-0 p-[var(--viewport-padding)] outline-none w-[390px] max-w-[100vw] pointer-events-none list-none [--viewport-padding:_25px]" />
    </>
  );
}

export function ToastProvider(props: RadixToast.ToastProviderProps) {
  return <RadixToast.Provider {...props}>{props.children}</RadixToast.Provider>;
}

Toast.Content = Content;
export default Toast;
